"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AddAnotherLineState = /** @class */ (function () {
    function AddAnotherLineState() {
        this.addAlineToggleOpen = false;
        this.deviceOptionSelected = false;
        this.ownDeviceOptionSelected = false;
        this.noThanksSelected = false;
        this.isFNModalOpen = false;
    }
    return AddAnotherLineState;
}());
exports.default = AddAnotherLineState;
//# sourceMappingURL=AddAnotherLineState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/AddALine/AddAnotherLineState.js
// module id = 2297
// module chunks = 8